import { FormControl } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const CategorySelectFormControl = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== 'isOpened' && prop !== 'inputWidth' && prop !== 'isDisabled'
})<{
  isOpened: string
  inputWidth?: string
  isDisabled?: string
}>`
  border: 1px solid ${theme.colors.strokePrimary};
  background: transparent;
  outline: none;
  height: 48px;
  width: ${({ inputWidth }) => inputWidth || '158px'};
  min-width: ${({ inputWidth }) => inputWidth || '158px'};
  max-width: ${({ inputWidth }) => inputWidth || '158px'};
  border-radius: ${theme.attributes.borderRadius.tertiary};

  .MuiOutlinedInput-root {
    width: 100%;
    height: 48px;
    background: transparent;
    border: 0;
    color: ${theme.colors.cta};
    text-align: left;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    letter-spacing: 0.1px;
    padding: 14px 51px 14px ${theme.spacing.small}px;
    cursor: pointer;
    text-overflow: ellipsis;
    overflow: hidden;

    .MuiSelect-select {
      padding: 0 !important;
      color: ${theme.colors.cta};

      > * {
        border: none !important;
        outline: none !important;
      }
    }

    .MuiSelect-nativeInput {
      cursor: pointer;
    }

    svg {
      transition: all 0.5s ease-in-out;
      cursor: pointer;
      right: 16px;
    }

    fieldset {
      outline: 0;
      border: 0;
    }
  }

  &:hover {
    .MuiOutlinedInput-root {
      color: ${theme.colors.cta};
    }

    svg {
      path {
        stroke: ${theme.colors.cta} !important;
      }
    }
  }

  ${({ isOpened }) =>
    isOpened === 'true' &&
    `
      border-color: ${theme.colors.cta} !important;
      outline: 0;

      .MuiOutlinedInput-root {
        color: ${theme.colors.cta};
      }

      svg {
        transform: rotate(180deg);

        path {
          stroke: ${theme.colors.cta} !important;
        }
      }
  `};

  ${({ isDisabled }) =>
    isDisabled === 'true' &&
    `
      border-color: ${theme.colors.borderMedium};
      pointer-events: none;
      opacity: 1;

      .MuiOutlinedInput-root {
        color: ${theme.colors.btnSecondaryDisabledText};
        cursor: default;

        .MuiSelect-select {
          color: ${theme.colors.btnSecondaryDisabledText} !important;
        }

        .MuiSelect-nativeInput {
          cursor: default;
        }

        svg path {
          stroke: ${theme.colors.btnSecondaryDisabledText} !important;
        }
      }

      &:hover {
        .MuiOutlinedInput-root {
          color: ${theme.colors.btnSecondaryDisabledText};
        }
        svg path {
          stroke: ${theme.colors.btnSecondaryDisabledText} !important;
        }
      }
  `};
`

export const getCategoryMenuProps = (dropdownWidth: string, anchorRight: boolean) => ({
  PaperProps: {
    sx: {
      marginTop: '4px',
      background: theme.colors.borderMedium,
      "html[data-theme='light'] &": {
        background: theme.colors.surfaceContainerBackground
      },
      boxShadow: '0px 4px 8px 0px rgba(30, 26, 29, 0.2)',
      borderRadius: theme.attributes.borderRadius.tertiary,
      border: 'none',
      minWidth: dropdownWidth,
      width: dropdownWidth,
      padding: 0,
      overflow: 'hidden',

      '.MuiList-root': {
        padding: 0
      },

      '.MuiMenuItem-root': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '42px',
        padding: `0 ${theme.spacing.small}px`,
        background: theme.colors.borderMedium,
        "html[data-theme='light'] &": {
          background: theme.colors.surfaceContainerBackground
        },

        '&:hover': {
          background: theme.colors.dropdownBorder,
          "html[data-theme='light'] &": {
            background: theme.colors.menuItemHover
          },

          '.MuiListItemText-root .MuiTypography-root': {
            color: theme.colors.menuItemText
          }
        },

        '.MuiListItemText-root .MuiTypography-root': {
          fontFamily: theme.typography.fontFamily.primary,
          fontWeight: theme.typography.fontWeight.bold,
          fontSize: theme.typography.fontSize.large,
          color: theme.colors.menuItemText,
          lineHeight: '22px',
          fontStyle: 'normal',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden'
        },

        '&.Mui-selected': {
          background: theme.colors.surfaceContainerBackground,
          "html[data-theme='light'] &": {
            background: theme.colors.menuItemHover
          }
        },

        '&[aria-selected="true"]': {
          '.MuiListItemText-root .MuiTypography-root': {
            color: theme.colors.cta
          }
        }
      }
    },
    style: {}
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: anchorRight ? ('right' as const) : ('left' as const)
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: anchorRight ? ('right' as const) : ('left' as const)
  },
  variant: 'menu' as const
})
